import { CustomValidators } from 'shared/validation/custom-validators';
import { countryLookup } from 'utils/lookups';

/* eslint-disable */
export const brandInfoSegmentData: any = [
  {
    "field_map": "companyName",
    "item_name": "company_name",
    "title": "Company Name",
    "hint_detail": "Company Name",
    "hint_panel" : "Company Name",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null
  },
  {
    // "item_name": "ZZZ-WEB",
    "field_map": "url",
    "item_name": "url",
    "title": "Website URL",
    "hint_detail": "Website URL",
    "hint_panel" : "Website URL",
    "example": "",
    "sequence": 2,
    "show_more": true,
    "lookup": null
  },
  {
    // "item_name": "ZZZ-ADD-1",
    "field_map": "address1",
    "item_name": "address_1",
    "title": "Mailing Address 1",
    "hint_detail": "Mailing Address 1",
    "hint_panel" : "Mailing Address 1",
    "example": "",
    "sequence": 3,
    "show_more": true,
    "lookup": null
  },
  {
    // "item_name": "ZZZ-ADD-2",
    "field_map": "address2",
    "item_name": "address_2",
    "title": "Mailing Address 2",
    "hint_detail": "Mailing Address 2",
    "hint_panel" : "Mailing Address 2",
    "example": "",
    "sequence": 4,
    "show_more": true,
    "lookup": null
  },
  {
    // "item_name": "ZZZ-CTY",
    "field_map": "city",
    "item_name": "city",
    "title": "City",
    "hint_detail": "City",
    "hint_panel" : "City",
    "example": "",
    "sequence": 5,
    "show_more": true,
    "lookup": null
  },
  {
    // "item_name": "ZZZ-STE",
    "field_map": "state",
    "item_name": "state",
    "title": "State",
    "hint_detail": "State",
    "hint_panel" : "State",
    "example": "",
    "sequence": 6,
    "show_more": true,
    "lookup": null
  },
  {
    // "item_name": "ZZZ-ZIP",
    "field_map": "zip",
    "item_name": "zip",
    "title": "Zip Code",
    "hint_detail": "Zip Code",
    "hint_panel" : "Zip Code",
    "example": "",
    "sequence": 7,
    "show_more": true,
    "lookup": null
  },
  {
    // "item_name": "ZZZ-COUNTRY",
    "field_map": "country",
    "item_name": "country",
    "title": "Country",
    "hint_detail": "Country",
    "hint_panel" : "Country",
    "example": "",
    "sequence": 8,
    "show_more": true,
    "lookup": countryLookup,
  },
  {
    // "item_name": "ZZZ-GEN-CON",
    "field_map": "email",
    "item_name": "email",
    "title": "General Contact Email",
    "hint_detail": "General Contact Email",
    "hint_panel" : "General Contact Email",
    "example": "john@doebrands.com",
    "sequence": 9,
    "show_more": true,
    "lookup": null,
    "validation": {
      'PIES_6_5': {
        maxLength: 254,
        validator: CustomValidators.email,
        message: 'A valid email must be provided and may not be longer than 254 characters'
      },
    },
  },
  {
    // "item_name": "ZZZ-PHONE",
    "field_map": "phone",
    "item_name": "phone",
    "title": "Phone",
    "hint_detail": "Phone",
    "hint_panel" : "Phone",
    "example": "",
    "sequence": 10,
    "show_more": true,
    "numerical": true,
    "lookup": null,
    "validation": {
      'PIES_6_5': {
        validator: CustomValidators.digits,
        message: 'Phone cannot have Alphabetical characters.'
      },
    }
  },
  {
    "field_map": "technicalContactName",
    "item_name": "technical_contact_name",
    "title": "Technical Contact name",
    "hint_detail": "Name of person to be contacted regarding data format issues.",
    "hint_panel" : "Enter the name of person to be contacted regarding data format issues.",
    "example": "John Doe",
    "sequence": 11,
    "show_more": true,
    "validation": {
      'PIES_6_5': {
        required: true,
        maxLength: 60,
        message: 'A technical contact name must be provided and is limited to 60 characters'
      },
    },
    "lookup": null
  },
  {
    "field_map": "technicalContactEmail",
    "item_name": "technical_contact_email",
    "title": "Technical contact email",
    "hint_detail": "Name of person to be contacted regarding data format issues.",
    "hint_panel" : "Enter the name of person to be contacted regarding data format issues.",
    "example": "jblack@email.com",
    "sequence": 12,
    "show_more": true,
    "lookup": null,
    "validation": {
      'PIES_6_5': {
        required: true,
        validator: CustomValidators.email,
        message: 'A technical contact email must be provided and must be like jblack@email.com.'
      },
    },
  },
  {
    "field_map": "facebook",
    "item_name": "facebook",
    "title": "Facebook",
    "hint_detail": "Facebook Page URL",
    "hint_panel" : "Facebook Page URL",
    "example": "",
    "sequence": 13,
    "show_more": true,
    "lookup": null
  },
  {
    "field_map": "linkedin",
    "item_name": "linkedin",
    "title": "LinkedIn",
    "hint_detail": "LinkedIn Profile URL",
    "hint_panel" : "LinkedIn Profile URL",
    "example": "",
    "sequence": 14,
    "show_more": true,
    "lookup": null
  },
  {
    "field_map": "twitter",
    "item_name": "twitter",
    "title": "Twitter",
    "hint_detail": "Twitter Account URL",
    "hint_panel" : "Twitter Account URL",
    "example": "",
    "sequence": 15,
    "show_more": true,
    "lookup": null
  },
  {
    "field_map": "instagram",
    "item_name": "instagram",
    "title": "Instagram",
    "hint_detail": "Instagram Account URL",
    "hint_panel" : "Instagram Account URL",
    "example": "",
    "sequence": 16,
    "show_more": true,
    "lookup": null
  },
  {
    "field_map": "youtube",
    "item_name": "youtube",
    "title": "YouTube",
    "hint_detail": "YouTube Page URL",
    "hint_panel" : "YouTube Page URL",
    "example": "",
    "sequence": 17,
    "show_more": true,
    "lookup": null
  },
  {
    "field_map": "description",
    "item_name": "description",
    "title": "General Description",
    "hint_detail": "General Description",
    "hint_panel" : "General Description",
    "example": "",
    "sequence": 18,
    "show_more": true,
    "lookup": null,
    "validation": {
      "DESCRIPTION": {
        maxLength: 2000,
        message: 'General Description is limited to 2000 characters'
      },
    },
  }
]
/* eslint-enable */
